import R from "ramda";
import { EventTypes } from "redux-segment";
import { SELECTED_ACCOUNT_ID, SELECTED_ACCOUNT_SLUG, storage } from "utils/local-storage";
import { setActiveAccount, putBetaViewedStatus } from "api/storage";
import { fetchDocuments } from "api/documents";

export const UNKNOWN_ERROR = "actions/app/unknown-error";
export const SET_FLASH_MESSAGE = "actions/app/set-flash-message";
export const CLEAR_FLASH_MESSAGE = "actions/app/clear-flash-message";
export const START_SETTINGS_MODE = "actions/app/start-settings-mode";
export const END_SETTINGS_MODE = "actions/app/end-settings-mode";
export const START_NOTIFICATIONS_MODE = "actions/app/start-notifications-mode";
export const END_NOTIFICATIONS_MODE = "actions/app/end-notifications-mode";
export const SET_EXPORT_FAILED_COUNT = "actions/app/set-export-failed-count";
export const SET_QUEUED_COUNT = "actions/app/set-queued-count";
export const END_GLOBAL_ERROR = "actions/app/end-global-error";
export const END_FIRST_TIME_BETA_MODE = "actions/app/end-first-time-beta-mode";
export const TOGGLE_BETA_MODAL = "actions/app/toggle-beta-modal";
export const START_TOUR = "actions/app/start-tour";
export const END_TOUR = "actions/app/end-tour";

export const globalErrorAction = () => ({ type: UNKNOWN_ERROR });

export const changeSelectedAccountAction = (accountId, accountSlug) => {
  storage.set(SELECTED_ACCOUNT_ID, accountId);
  storage.set(SELECTED_ACCOUNT_SLUG, accountSlug);
  setTimeout(() => {
    document.location.href = `/accounts/${accountSlug}/documents`;
  }, 0);
  return {
    type: "NOOP",
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: { event: "Change account" }
      }
    }
  };
};

export const setFlashMessageAction = (message, type = "success") => ({
  type: SET_FLASH_MESSAGE,
  data: { message, type }
});

export const setFlashGenericErrorAction = () => ({
  type: SET_FLASH_MESSAGE,
  data: { message: "Oops! An error occurred. Please try again later", type: "error" }
});

export const clearFlashMessageAction = () => ({
  type: CLEAR_FLASH_MESSAGE
});

export const startSettingsModeAction = () => ({
  type: START_SETTINGS_MODE
});

export const endSettingsModeAction = () => ({
  type: END_SETTINGS_MODE
});

export const setActiveAccountAction = (accountId) => {
  setActiveAccount(accountId);
  return {
    type: "NOOP"
  };
};

export const startNotificationsModeAction = () => ({
  type: START_NOTIFICATIONS_MODE
});

export const endNotificationsModeAction = () => ({
  type: END_NOTIFICATIONS_MODE
});

export const fetchDocumentsAction = (accountId, filters) => (dispatch) => {
  const exportFailedFilters = R.set(R.lensProp("selectedCategories"), ["Export failed"], filters);
  const queuedFilters = R.set(R.lensProp("selectedCategories"), ["Queued for Export"], filters);
  const pagination = {
    pageNumber: 1,
    limit: 1,
    totalCountFiltered: 0
  };
  return Promise.all([
    dispatchExportFailedPromise(accountId, exportFailedFilters, pagination, dispatch),
    dispatchQueuedPromise(accountId, queuedFilters, pagination, dispatch)
  ]);
};

const dispatchExportFailedPromise = (accountId, filters, pagination, dispatch) => (
  fetchDocuments(accountId, filters, pagination)
    .then(({ totalCountFiltered }) => {
      dispatch({
        type: SET_EXPORT_FAILED_COUNT,
        data: { exportFailedCount: totalCountFiltered }
      });
    })
);

const dispatchQueuedPromise = (accountId, filters, pagination, dispatch) => (
  fetchDocuments(accountId, filters, pagination)
    .then(({ totalCountFiltered }) => {
      dispatch({
        type: SET_QUEUED_COUNT,
        data: { queuedCount: totalCountFiltered }
      });
    })
);

export const endGlobalErrorAction = () => ({
  type: END_GLOBAL_ERROR
});

export const endFirstTimeBetaModeAction = (dontRemind) => (dispatch) => {
  if (dontRemind) {
    return putBetaViewedStatus(true)
      .then(() => dispatch({ type: END_FIRST_TIME_BETA_MODE }));
  }
  return dispatch({ type: END_FIRST_TIME_BETA_MODE });
};

export const toggleBetaModalAction = (toggle) => ({
  type: TOGGLE_BETA_MODAL,
  data: { toggle }
});

export const startTourAction = (tour) => ({
  type: START_TOUR,
  data: { tour }
});

export const endTourAction = () => ({
  type: END_TOUR
});




// WEBPACK FOOTER //
// ./src/js/actions/app-actions.js